<template>
    <div class="d-flex flex-column schema-table">
        <div v-if="!tableOnly" class="d-flex align-center mb-5 schema-table-toolbar">
            <v-text-field
                v-model="searchInput"
                class="no-print"
                label="Search"
                hide-details
                dense
                color="primary"
                outlined
                prepend-inner-icon="mdi-magnify"
                @keyup.enter="applySearch" />

            <slot name="add-button">
                <app-icon-button
                    v-if="canAdd"
                    class="ml-4 no-print"
                    color="primary"
                    icon="mdi-plus"
                    @click="add" />
            </slot>

            <schema-excel-export-button
                v-if="!disableExport"
                v-bind="$attrs"
                class="ml-4 no-print"
                :entity-key="entityKey"
                :scope="scope"
                :list-request="listRequest" />
        </div>

        <v-card :class="cardClasses" :elevation="outlined ? 0 : 4">
            <component
                :is="tableComponent"
                :key="entityKey"
                ref="schemaDataTable"
                class="schema-data-table-component"
                v-bind="$attrs"
                :entity-key="entityKey"
                :search-text="searchText"
                :scope="scope"
                :readonly="readonly"
                :has-item-page="hasItemPage"
                :edit-disabled="editDisabled"
                @list-request="setListRequest"
                @edit="edit">
                <template #extra-actions="{ item }">
                    <slot name="extra-actions" :item="item" />
                </template>
            </component>
        </v-card>

        <schema-form-dialog
            :entity-key="entityKey"
            :scope="scope"
            :value="editedItem"
            :form="form"
            v-bind="$attrs"
            @input="onItemSaved" />
    </div>
</template>

<script>
import tableMixin from "@/features/schemas/mixins/tableMixin";

export default {
    mixins:[tableMixin],
    types: [
        "default"
    ],
    data() {
        return {
            searchInput: ""
        };
    },
    methods: {
        applySearch() {
            this.searchText = this.searchInput;
        }
    }
};
</script>

<style lang="scss" scoped>
.schema-table {
    height: 100%;
    overflow: hidden;
}

.schema-table-toolbar {
    flex-shrink: 0;
}

.schema-data-table-component {
    height: 100%;
}

.v-card {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
}

.outlined-card {
    border: 0.0625rem solid #e0e0e0;
}
</style>
